import { FlexRow, ScreenTitle } from "src/style"
import { useState } from "react"
import BackIcon from 'src/assets/svg/back-icon-d3'

export const TitleWithBackIconD3: React.FC<any> = ({title, backMethod}) => {
    const [isHover, setIsHover] = useState(false)
    return (
        <FlexRow 
            width="auto" sizeUnit="" bottomMargin="2.5"
            className="module-row-title"
        >
            { backMethod != undefined &&
                <BackIcon 
                    isHover={isHover} 
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                    onClick={backMethod}
                    className='icon-component'
                    style={{marginRight: '2rem'}}
                />
            }
            <ScreenTitle 
                textSize="2" fontWeight="600"
                color="#211121"
            >
                {title}
            </ScreenTitle>
        </FlexRow>
        
    )
}